import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {OAuthService} from 'angular-oauth2-oidc-codeflow';
import {User} from '../_models/user.model';
import {RendererService} from '../_services/renderer.service';
import {KeycloakService} from 'keycloak-angular';

@Injectable({ providedIn: 'root' })
export class CapaAuthGuard implements CanActivate {

    constructor(private router: Router,
                private oAuthService: OAuthService,
                private renderService: RendererService,
                private keycloakService: KeycloakService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (localStorage.getItem('currentUser') != null) {
            const currentUser: User = JSON.parse(localStorage.getItem('currentUser'));
            // Si il est admin capa clhub
            if (this.keycloakService.isUserInRole('clhub-admin-capa')) {
                // Il est autorisé
                localStorage.setItem('isCapaAdmin', 'true');
                this.renderService.config.menu = true;
            }
            return true;
        }
        // Si il est connectté à keycloak
        if (this.oAuthService.hasValidAccessToken()) {
            // Et connecté à CAPA
            if (localStorage.getItem('capaAccount') != null) {
                return true;
            } else {
                this.oAuthService.logOut();
                this.router.navigate(['capa'], {});
                return false;
            }
        } else {
            localStorage.removeItem('capaAccount');
            this.router.navigate(['capa'], {});
            return false;
        }
    }
}
